import { Button, Col, Form, Input, message, Row } from "antd";
import { useState } from "react";
import { useLoginMutation } from "../../query/admin.query";
import util from "../../utils/util";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Login() {
	const navigate = useNavigate();
	const [data, setData] = useState({});
	const loginMutation = useLoginMutation();
	const login = () => {
		loginMutation.mutate(
			{ ...data },
			{
				onSuccess: (res) => {
					util.setUserData(res.data);
					  window.location.href = "/";
				},
				onError: (err) => {
					if (typeof err.message !== "string") {
						message.error(err.message[Object.keys(err.message)[0]][0]);
					} else {
						message.error(err.message);
					}
				}
			}

		)
	};

	return (
		<>
			<div className="bg-gray-100 flex justify-center items-center h-screen">
				<div className="w-9/12 hidden animated-background h-screen bg-gradient-to-br from-[#D7C28D] via-[#c4a574] to-[#977731] lg:flex justify-center flex-col px-8 relative">
					<div className="flex items-center gap-x-2">
					<img src="/logo.png" alt="logo" className="w-[300px] h-[100px]  object-contain" />
					{/* <p className="text-xl text-white font-semibold"></p> */}
					</div>
					<p className="text-5xl font-medium my-4 text-white">Welcome,</p>
					<p className="text-5xl font-medium my-3 text-white">
						To Your Dashboard! 👋
					</p>
					<p className="text-center absolute bottom-0 w-full mb-2 text-[1rem] text-[#1D1D1D]">
						© 2024 Pruden. All right reserved
					</p>
				</div>
				<div className="lg:p-36 md:p-52 sm:20 p-8 w-full lg:w-1/2">
					<h1 className="text-2xl font-semibold mb-4">Login 🚀</h1>
					<Form
						layout="vertical"
						size="large"
						onSubmitCapture={login}
					>
						<Row gutter={[12, 2]} span={20}>
							<Col span={24}>
								<Form.Item>
									<Input
										placeholder="Email"
										value={data.code}
										onChange={(e) => {
											setData({
												...data,
												code: e.target.value,
											});
										}}
									/>
								</Form.Item>
							</Col>
							<Col span={24}>
								<Form.Item>
									<Input.Password
										placeholder="Password"
										value={data.password}
										onChange={(e) => {
											setData({
												...data,
												password: e.target.value,
											});
										}}
									/>
								</Form.Item>
							</Col>
							<Col span={24}>
  <div className="flex justify-end mb-2">
    <Link
      to="/forgot-password"
      className="text-[#977731] hover:underline hover:text-[#7a6028] text-sm font-medium"
    >
      Forgot Password?
    </Link>
  </div>
</Col>
							<Col span={24} className="my-4">
								<Button
									type="primary"
									htmlType="submit"
									block
									loading={loginMutation.isPending}
								>
									Access Now
								</Button>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
		</>
	);
}
